import RootState from 'store/state';
import { useSelector } from 'react-redux';

export default function useUser(): RootState["user"] {

    const user = useSelector<RootState, RootState["user"]>(
        ({ user }) => user
    )

    return user
}
